import { LoaderWrapper, Loader } from 'components';

const PageLoader: React.FC<{}> = () => {
  return (
    <LoaderWrapper>
      <Loader themeColor="darkBlue" />
    </LoaderWrapper>
  );
};

export default PageLoader;
